import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import SuccessCasesItem from '../SuccessCasesItem';

const SuccessCases = ({ successCasesList }: { successCasesList: any[] }) => {
  const t = useTranslations();
  return (
    <div className="mb-[7.8vw] box-border flex w-full flex-row items-center justify-start pl-[9.984vw] max-md:hidden">
      <div className="mr-[1.872vw] flex h-[26vw] w-[17.68vw] flex-col items-start justify-center">
        <h2 className="mb-[1.04vw] text-[2.392vw] font-semibold leading-tight text-[#111111]">
          星环移民留学
          <br />
          成功案例分享
        </h2>
        <h2 className="mb-[1.924vw] text-[1.872vw] font-extrabold uppercase leading-[1.872vw] text-[#E2E2E2]">
          {t('Home.successCasesEnglishText')}
        </h2>
        <div className="mb-[3.952vw] w-[17.68vw] text-[0.936vw] font-normal leading-[1.612vw] text-[#666666]">
          {t('Home.successCasesDescription')}
        </div>
        <Link
          href="/successful-cases"
          className="mb-[1.144vw] flex cursor-pointer flex-row items-center justify-start"
          // onClick={() => {
          //   window.open(process.env.NEXT_PUBLIC_WEBSITE + '/all_successful_cases/', '_blank');
          // }}
        >
          <div className="mr-[0.624vw] text-[0.936vw] font-normal leading-[0.936vw] text-[#333333]">
            {t('Home.seeMore')}
          </div>
          <Image
            src={'/images/home/rightArrow.png'}
            width={26}
            height={13}
            className="h-auto w-[1.352vw]"
            alt="rightArrow"
          />
        </Link>
        <div className="h-[1px] w-[17.68vw] bg-[#656565]"></div>
      </div>
      <div className="mr-[0.832vw] w-[2.316vw]"></div>
      <Carousel
        opts={{
          align: 'start',
        }}
        style={{ width: 'calc(100% - 17.68vw - 1.872vw - 2.316vw - 0.832vw - 4.316vw)' }}
      >
        <CarouselContent className="ml-0">
          {successCasesList.map((item, index) => (
            <CarouselItem key={index} className={`basis-1/3`}>
              <SuccessCasesItem key={index} {...item} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="-left-[4.792vw] top-[12.868vw] h-[4.368vw] w-[4.316vw] border-none shadow-none" />
        <CarouselNext className="-right-[4.316vw] top-[12.868vw] h-[4.368vw] w-[4.316vw] border-none opacity-80 shadow-none hover:opacity-100" />
      </Carousel>
    </div>
  );
};

export default SuccessCases;
